<template>
    <div>
        <div class="container-fluid">
            <div class="d-flex fundo-panel">
                <div class="div-select">
                    <vue-select v-model="ModuloSelected" :options="modulos" :label-by="(e) => (e.nmModulo)"
                                placeholder="Digite e selecione o nome do módulo" searchable search-placeholder="Pesquise"
                                close-on-select clear-on-select :min="1" class="form-control ms-2 shadow-v2">
                    </vue-select>
                </div>
                <div class="ms-3" style="        min-width: 450px;" v-if="ModuloSelected.flEquipeEvento">
                    <DropdowEventos @input_evento="input_evento" :options="eventos" :label-by="(e) => (e.nmEvento)"
                                    placeholder="Digite e selecione o evento" searchable search-placeholder="Pesquise" close-on-select
                                    clear-on-select :min="1" class="form-control shadow-v2 " :reset="reset" @return_dropEvento_reset="return_dropEvento_reset">
                    </DropdowEventos>
                </div>
                <div class="flex-grow-1 ms-3">
                    <InputSearch v-model="filtro_text" placeholder="Pesquisar Pelo Nome do Participante, Nome da Instituição, CNPJ, ou CPF..." @updateSearch="reloadGrid" @keypress.enter="performSearch" />
                </div>
                <div class="ms-auto me-2">
                    <div class="d-flex">
                        <div class="ms-2">
                            <button class="btn-style-white btn-refresh" @click="reloadGrid()">
                                <i class="fas fa-sync"></i>
                            </button>
                        </div>
                        <div class="ms-2">
                            <a class="btn-t btn btn-order" href="#" role="button" @click="toggleFilters">
                                <i class="fas fa-solid fa-filter"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <!-- FILTROS -->
            <transition name="backdrop" v-show="ModuloSelected.idModulo > 0">
                <div class="backdrop" v-if="showFilters"></div>
            </transition>
            <transition name="fade">
                <InputFilters v-if="showFilters" :styleFilter="'background: #f9f9f9; border-top-left-radius: 0; border-top-right-radius: 0;'">
                    <template v-slot:body>
                        <div class="row mt-2 mb-0 ms-1">
                            <div class="col-4">
                                <label class="form-label">Localizador</label>
                                <Field label="cdLocalizador" name="cdLocalizador" class="form-control hig-Input shadow-v2"
                                       v-model="filtros_Crud.cdLocalizador" :class="{ filled: filtros_Crud.cdLocalizador }"
                                       @keypress.enter="performSearch" />
                            </div>
                            <div class="col-4">
                                <label class="form-label">Passaporte</label>
                                <Field label="cdPassaporte" name="cdPassaporte" class="form-control hig-Input shadow-v2"
                                       v-model="filtros_Crud.cdPassaporte" :class="{ filled: filtros_Crud.cdPassaporte }"
                                       @keypress.enter="performSearch" />
                            </div>
                            <div class="col-4">
                                <label class="form-label">Âmbito</label>
                                <vue-select v-model="filtro_ambitos_selects" :options="filtro_ambitos"
                                            :label-by="(e) => (e.nmAmbito)" placeholder="Selecione o Âmbito" searchable
                                            search-placeholder="Pesquise" close-on-select class="form-control shadow-v2 low-Input"
                                            @input="handleSelectAll" :class="{ filled: filtro_ambitos_selects.idAmbito > 0 }">
                                </vue-select>
                            </div>
                        </div>
                        <div class="row mt-2 mb-0 ms-1">
                            <div class="col-4">
                                <label class="form-label">Empenho</label>
                                <select id="select-empenho" class="form-select shadow-v2 text-muted"
                                        style="font-size: 14px;" v-model="filtros_Crud.flEmpenho"
                                        :class="{ filled: filtros_Crud.flEmpenho }">
                                    <option selected value="">Todos</option>
                                    <option value="Finalizado">Finalizado</option>
                                    <option value="Andamento">Andamento</option>
                                </select>
                            </div>
                            <div class="col-4">
                                <label class="form-label">Estados</label>
                                <vue-select v-model="filtro_estados_selects" :options="$estados"
                                            placeholder="Selecione o Estado" class="form-control shadow-v2 low-Input" multiple
                                            taggable :class="{ filledInput: filtro_estados_selects != '' }">
                                </vue-select>
                            </div>
                            <div class="col-4">
                                <label class="form-label" name="idAmbito">Consultor</label>
                                <select id="select-consultor" class="form-select shadow-v2 text-muted"
                                        style="font-size: 14px;" v-model="filtros_Crud.dsLoginConsultor"
                                        :class="{ filled: filtros_Crud.dsLoginConsultor }">
                                    <option selected value="" v-if="verificaPermissao()">Todos</option>
                                    <option v-for="consultor in equipe" :key="consultor.nmUsuario"
                                            :value="consultor.dsLogin">
                                        {{ consultor.nmUsuario }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="row mt-2 mb-0 ms-1">
                            <div class="col-4">
                                <label class="form-label">Cadastro NP Events</label>
                                <select id="select-npevents" class="form-select shadow-v2 text-muted"
                                        style="font-size: 14px;" v-model="filtros_Crud.flNpEvents"
                                        :class="{ filled: filtros_Crud.flNpEvents }">
                                    <option selected value="">Todos</option>
                                    <option value="Sim">Sim</option>
                                    <option value="Não">Não</option>
                                </select>
                            </div>
                            <div class="col-4">
                                <label class="form-label">Origem Inscrição</label>
                                <select id="select-origem" class="form-select shadow-v2 text-muted"
                                        style="font-size: 14px;" v-model="filtros_Crud.tpOrigemInscricao"
                                        :class="{ filled: filtros_Crud.tpOrigemInscricao }">
                                    <option selected value="">Todos</option>
                                    <option value="Externo">Externo</option>
                                    <option value="Interno">Interno</option>
                                </select>
                            </div>
                            <div class="col-4">
                                <label class="form-label" name="idAmbito">Tipo Inscrição</label>
                                <select id="select-tipo" class="form-select shadow-v2 text-muted"
                                        style="font-size: 14px;" v-model="filtros_Crud.idTipoInscricao"
                                        :class="{ filled: filtros_Crud.idTipoInscricao }">
                                    <option selected value="0">Todos</option>
                                    <option value="1">Presencial</option>
                                    <option value="2">Online</option>
                                </select>
                            </div>
                        </div>

                        <div class="row mb-2 ms-1">
                            <div class="d-flex justify-content-start mt-4">

                                <label class="form-control-checkbox me-4">
                                    <input type="checkbox" v-model="filtro_flCancelado" /> Passaporte Cancelado
                                </label>

                                <label class="form-control-checkbox me-4">
                                    <input type="checkbox" v-model="filtro_flSemPassaporte" /> Sem Passaporte
                                </label>

                                <label class="form-control-checkbox me-4">
                                    <input type="checkbox" v-model="filtro_flSemAtribuir" /> Sem Atribuir
                                </label>


                                <label class="form-control-checkbox me-4">
                                    <input type="checkbox" v-model="filtro_flSemOficina" /> Sem Oficina
                                </label>


                                <label class="form-control-checkbox me-4">
                                    <input type="checkbox" v-model="filtro_flSemConfirmado" /> Sem Confirmação
                                </label>


                                <label class="form-control-checkbox me-4">
                                    <input type="checkbox" v-model="filtro_flSemCredenciamento" /> Sem Credenciamento
                                </label>

                            </div>
                        </div>


                        <div class="col-12 row mt-4 ps-4">
                            <div class="col-6 d-flex">
                                <button class="btn-white-v2" @click="closeFilters">
                                    Fechar
                                </button>
                                <button class="ms-1 btn-white-v2 v3" @click="clearFiltros">
                                    <i class="fa fa-window-close pe-2"></i>
                                    Limpar
                                </button>
                            </div>
                            <div class="col-6 d-flex justify-content-end">
                                <button class="btn-red-v2" @click="getFiltros">
                                    <i class="fa fa-search pe-2"></i>
                                    Filtrar
                                </button>
                            </div>
                        </div>
                    </template>
                </InputFilters>
            </transition>


            <div class="d-flex d-flex-tabs">
                <div v-for="(tab, index) in valoresTabs" :key="tab.dsStatus" class="tabs mb-0 flex-fill" v-on:click="setTabDataTable(index)">
                    <div :class="tab.class">
                        <span class="tabs-title">{{ tab.text }}</span>
                        <span class="tabs-valor"> {{ tab.value }}</span>
                    </div>
                </div>
            </div>


            <!-- DATATABLE MAIN -->
            <div>
                <DataTable :url_ajax="getUrlInscricoes()" :ajax_set_result="setResult" @grid_refreshed="gridRefreshed"
                           :refresh="refresh_grid" :filtros="filtro" method="GET" :qtd_registros_por_pagina="20" :is_table="true"
                           :footer_fixed="true" :headers="header_selected" :pBtnsSlot="true" :is_NotLoading="NotLoading"
                           borderBottom="border-bottom: 1px solid grey" dataPadd="ps-2"
                           customHeight="margin-top: 0px !important;max-height: calc(100vh - 13.2rem);min-height: calc(100vh - 13.2rem);"
                           customHeightPaginate="margin-top: 0px !important;max-height: calc(100vh - 13.2rem);min-height: calc(100vh - 13.2rem);"
                           customCssRow="padding-left: 22px;padding-right: 22px" :flMostraTotalRegistros="true"
                           sizeWidBootonNopaginate="margin-left:-2px" @retorna_total_registros="retorna_total_registros"
                           class="mt-2" :column_slot="true">
                    <template v-slot:cell-slot_cdLocalizador="item">
                        <div class="d-flex justify-content-center">



                            <div class="d-flex flex-column mt-1 mb-2" data-bs-custom-class="custom-tooltip"  data-bs-toggle="tooltip" data-bs-placement="right" :title="item.row.dsLoginConsultor">
                                <div class="text-center fw-bold"><a :href="'https://gnp.negociospublicos.net.br/NP/Eventos/Inscricao/InscricaoParticipantes/?p_cdLocalizador=' + item.row.cdLocalizador" target="blank">{{ item.row.cdLocalizador }}</a></div>
                                <div class="text-center text-danger fw-bold" v-if="item.row.tpOrigem == 'Comercial'">Interno</div>
                                <div class="text-success fw-bold" v-else-if="item.row.tpOrigem == 'site'">Externo</div>
                                <div class="text-success fw-bold" v-else-if="item.row.tpOrigem == 'importação'">Importação</div>
                                <div class="text-success fw-bold" v-else>Nenhum</div>
                                <div class="text-center fw-bold" v-if="item.row.flPagamentoCartao != 'Sim'"><a :href="'https://gnp.negociospublicos.net.br/NP/Eventos/Inscricao/inscricaoPagamentoCartao/?p_cdLocalizador=' + item.row.cdLocalizador" target="blank">Pagar</a></div>
                                <div class="text-center fw-bold" v-else><span class="text-success">Pago</span></div>                              
                            </div>



                        </div>
                    </template>
                    <template v-slot:cell-slot_nmUf="item">
                        <div style="min-width: 100px; height: 100%; text-align:left;">
                            Data: {{ formatarData(item.row.dtInclusao) }} | UF: <strong>{{ item.row.nmUf }}</strong><br>
                            <div style="width: 100%; height: 100%; text-align:left;">
                                {{ item.row.nmNome }}
                            </div>
                        </div>
                    </template>
                    <template v-slot:cell-slot_flVinculado="item">
                        <div v-if="item.row.tpInstituicao == 'F' && (item.row.idInstituicao != null && item.row.idInstituicao > 0)" class="spinner-grow-static text-success" role="status" />
                        <div v-else-if="item.row.tpInstituicao == 'J' && (item.row.idInstituicao != null && item.row.idInstituicao > 0)" class="spinner-grow-static text-success" role="status" />
                        <div v-else class="spinner-grow-static text-danger" role="status" />
                    </template>
                    <template v-slot:cell-slot_flCancelado="item">
                        <div>
                            <button class="btn btn-light text-success btn-ativo" v-on:click="openModalStatusInscricao(item.row.idInscricao)" v-if="item.row.flCancelado != 'Sim'">
                                <i class="fas fa-check"></i>
                            </button>
                            <button class="btn btn-light text-danger btn-ativo" v-on:click="openModalStatusInscricao(item.row.idInscricao)" v-else>
                                <i class="fas fa-times"></i>
                            </button>
                        </div>
                    </template>
                    <template v-slot:cell-slot_qtdParticipantesCadastrados="item">
                        <span :class="getStyleqtdParticipantesCadastrados(item.row.qtdParticipantesCadastrados, item.row.qtdParticipantes)">
                            {{ item.row.qtdParticipantesCadastrados }} / {{ item.row.qtdParticipantes }}
                        </span>
                    </template>
                    <template v-slot:cell-slot_qtdParticipantesOficinas="item">
                        <span :class="getStyleqtdParticipantesOficinas(item.row.qtdParticipantesOficinas, item.row.qtdParticipantes)">
                            {{ item.row.qtdParticipantesOficinas }} / {{ item.row.qtdParticipantes }}
                        </span>
                    </template>
                    <template v-slot:cell-slot_qtdParticipantesConfirmados="item">
                        <span :class="getStyleqtdParticipantesConfirmados(item.row.qtdParticipantesConfirmados, item.row.qtdParticipantes)">
                            {{ item.row.qtdParticipantesConfirmados }} / {{ item.row.qtdParticipantes }}
                        </span>
                    </template>
                    <template v-slot:cell-slot_qtdParticipantesCredenciados="item">
                        <span :class="getStyleqtdParticipantesCredenciados(item.row.qtdParticipantesCredenciados, item.row.qtdParticipantes)">
                            {{ item.row.qtdParticipantesCredenciados }} / {{ item.row.qtdParticipantes }}
                        </span>
                    </template>
                    <template v-slot:cell-slot_cdPassaporte="item">
                        <div class="d-flex justify-content-center">
                            <div class="d-flex flex-column mt-1 mb-2">
                                <div class="text-center fw-bold">{{ item.row.cdPassaporte }}</div>
                            </div>
                        </div>
                    </template>
                    <template v-slot:cell-slot_nmParticipante="item">
                        <div class="d-flex ">
                            <div class="d-flex flex-column mt-1 mb-2">
                                <span>{{ item.row.nmParticipante }}</span>
                            </div>
                        </div>
                    </template>
                    <template v-slot:cell-slot_dsEmail="item">
                        <div class="d-flex ">
                            <div class="d-flex flex-column mt-1 mb-2">
                                <div>
                                    <span class="fw-bold">{{ item.row.nmUf }}</span>
                                    <span> / {{ item.row.dsEmail }}</span>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-slot:cell-slot_flVinculado_Participante="item">
                        <div v-if="item.row.tpInstituicao == 'J'">
                            <div v-if="(item.row.idPessoa > 0 && item.row.idInstituicao > 0)" class="spinner-grow-static text-success" role="status" />
                            <div v-else class="spinner-grow-static text-danger" role="status" />
                        </div>
                        <div v-else-if="item.row.tpInstituicao == 'F'">
                            <div v-if="(item.row.idPessoa > 0)" class="spinner-grow-static text-success" role="status" />
                            <div v-else class="spinner-grow-static text-danger" role="status" />
                        </div>
                    </template>
                    <template v-slot:cell-slot_flCancelado_Participante="item">
                        <div>
                            <button class="btn btn-light text-success btn-ativo" v-on:click="openModalStatusParticipante(item.row.idParticipante)" v-if="item.row.flCancelado != 'Sim'">
                                <i class="fas fa-check"></i>
                            </button>
                            <button class="btn btn-light text-danger btn-ativo" v-on:click="openModalStatusParticipante(item.row.idParticipante)" v-else>
                                <i class="fas fa-times"></i>
                            </button>
                        </div>
                    </template>


                    <template v-slot:BtnSlot="item">

                        <div class="row justify-content-end" v-if="item.row.idParticipante > 0">
                            <button class="btn-grid-editar-lista" style="width: max-content;margin: 0;height: 35px;" type="button" @click="openModalParticipante(item.row.idInscricao, item.row.idParticipante)">
                                <i class="fas fa-pencil-alt"></i>
                            </button>

                            <button class="btn-grid-editar-lista ms-1" style="width: max-content;margin: 0;height: 35px; " type="button" v-if="item.row.idOcorrencia > 0" v-on:click="abreOcorrencia(item.row.idOcorrencia)">
                                <i class="fas fa-eye"></i>
                            </button>

                            <button class="btn-grid-editar-lista ms-1" style="width: max-content;margin: 0;height: 35px;" type="button" @click="openModalDisparo(item.row.idInscricao, item.row.idParticipante)">
                                <i class="fas fa-envelope"></i>
                            </button>

                            <a class="btn-grid-editar-lista ms-1" :href="'https://gnp.negociospublicos.net.br/NP/Eventos/Oficina/?p_cdPassaporte=' + item.row.cdPassaporte" target="blank" style="width: max-content;margin: 0;height: 35px;  margin-right:2px;"> <i class="fas fa-graduation-cap"></i></a>

                        </div>

                        <div class="row justify-content-end" v-else>
                            <button class="btn-grid-editar-lista" style="width: max-content;margin: 0;height: 35px;" type="button" @click="openModalInscricao(item.row.idInscricao)">
                                <i class="fas fa-pencil-alt"></i>
                            </button>
                            <button class="btn-grid-editar-lista ms-1" style="width: max-content;margin: 0;height: 35px; " type="button" v-if="item.row.idOcorrencia > 0" v-on:click="abreOcorrencia(item.row.idOcorrencia)">
                                <i class="fas fa-eye"></i>
                            </button>
                            <button class="btn-grid-editar-lista ms-1" style="width: max-content;margin: 0;height: 35px;" type="button" @click="openModalParticipantes(item.row.idInscricao)">
                                <i class="fas fa-users"></i>
                            </button>
                            <button class="btn-grid-editar-lista ms-1  " style="width: max-content;margin: 0;height: 35px; margin-right:2px;" type="button" @click="openModalDisparo(item.row.idInscricao, item.row.idParticipante)">
                                <i class="fas fa-envelope"></i>
                            </button>
                        </div>


                    </template>
                </DataTable>
            </div>
        </div>

        <!--OK-->

        <modal-warper target="status_inscricao_2" :show="isOpenModalStatusInscricao" @close="isOpenModalStatusInscricao = false">
            <Status_Inscricao :id="'status_inscricao_2'" :idInscricao="grid_inscricao_selected" :show="isOpenModalStatusInscricao" @reloadAll="reloadAll" />
        </modal-warper>

        <modal-warper target="status_participante_2" :show="isOpenModalStatusParticipante" @close="isOpenModalStatusParticipante = false">
            <Status_Participante :id="'status_participante_2'" :idParticipante="grid_participante_selected" :show="isOpenModalStatusParticipante" @reloadAll="reloadAll" />
        </modal-warper>

        <modal-warper target="participantes" :show="isOpenModalParticipantes" @close="isOpenModalParticipantes = false">
            <Participantes :idModulo="ModuloSelected.idModulo" :idEvento="EventoSelected.idEvento" :idInscricao="grid_inscricao_selected" :show="isOpenModalParticipantes" />
        </modal-warper>

        <modal-warper target="disparo_alerta_2" :show="isOpenModalDisparoAlerta" @close="isOpenModalDisparoAlerta = false">
            <DisparoAlerta :id="'disparo_alerta_2'" :idEvento="EventoSelected.idEvento" :idInscricao="grid_inscricao_selected" :idParticipante="grid_participante_selected" :show="isOpenModalDisparoAlerta" />
        </modal-warper>

        <!--OK-->



        <modal-warper target="participante" :show="isOpenModalParticipante" @close="isOpenModalParticipante = false">
            <Participante :idEvento="EventoSelected.idEvento" :idInscricao="grid_inscricao_selected" :idParticipante="grid_participante_selected" :show="isOpenModalParticipante" />
        </modal-warper>

        <modal-warper target="inscricao" :show="isOpenModalInscricao" @close="isOpenModalInscricao = false">
            <Inscricao :idEvento="EventoSelected.idEvento" :idInscricao="grid_inscricao_selected" :show="isOpenModalInscricao" @fecharModal="fecharModal()" />
        </modal-warper>







        <modal-warper target="ModalTicket" :show="isOpenModalOcorrencia" @close="(isOpenModalOcorrencia = false)">
            <Ocorrencia :p_exibir="isOpenModalOcorrencia" :p_idModulo="ModuloSelected.idModulo" :p_idOcorrencia="p_idOcorrencia" :p_cdOcorrenciaTab="17"></Ocorrencia>
        </modal-warper>

    </div>
</template>

<script>

    import axios from "axios";
    import VueNextSelect from "vue-next-select";
    import "vue-next-select/dist/index.min.css";
    import DataTable from "@/components/App/Datatable.vue";
    import InputSearch from "@/components/App/Input_Search.vue";
    import moment from "moment";
    import { maska } from "maska";
    /*    import DateInput from "@/components/App/DateInput.vue";*/
    import InputFilters from "@/components/App/Input_Filters.vue";
    import $ from "jquery";
    import ModalWarper from "@/components/App/ModalWarper.vue";
    import Modal from "@/components/App/Modal.vue";
    import DisparoAlerta from '@/views/Gerencial/GestaoEvento/GerenciamentoInscricoes/Modais/DisparoAlerta.vue'
    import Status_Inscricao from '@/views/Gerencial/GestaoEvento/GerenciamentoInscricoes/Modais/Status_Inscricao.vue'
    import Status_Participante from '@/views/Gerencial/GestaoEvento/GerenciamentoInscricoes/Modais/Status_Participante.vue'
    import Participantes from '@/views/Gerencial/GestaoEvento/GerenciamentoInscricoes/Modais/Participantes.vue'
    import Participante from '@/views/Gerencial/GestaoEvento/GerenciamentoInscricoes/Modais/Participante.vue'
    import Inscricao from '@/views/Gerencial/GestaoEvento/GerenciamentoInscricoes/Modais/Inscricao.vue'
    import DropdowEventos from '@/components/App/DropdowEventos.vue'
    import Ocorrencia from "@/views/Modais/Ocorrencia/Ocorrencia.vue";

    export default {
        emits: ['setActionCard'],
        name: "GerenciamentoInscricoes",
        components: {
            "vue-select": VueNextSelect,
            DataTable,
            /*     Modal,*/
            InputSearch,
            InputFilters,
            /*  DateInput,*/
            ModalWarper,
            DisparoAlerta,
            Status_Inscricao,
            Status_Participante,
            Participantes,
            Participante,
            Inscricao,
            Ocorrencia,
            DropdowEventos,
        },
        data() {
            return {
                isOpenModalOcorrencia: false,
                p_idOcorrencia: 0,

                filtro_estados_selects: [],
                filtro_ambitos: [],
                filtro_ambitos_selects: { idAmbito: 0 },
                isOpenModalDisparoAlerta: false,
                isOpenModalStatusInscricao: false,
                isOpenModalStatusParticipante: false,

                isOpenModalParticipantes: false,
                isOpenModalParticipante: false,
                isOpenModalInscricao: false,

                modulos: [],

                valoresTabs: [],
                ModuloSelected: { idModulo: 0 },

                eventos: [],
                EventoSelected: { idEvento: 0 },


                dsLoginConsultor: '',
                idInstituicao: 0,
                idModulo: 0,
                idModuloTicket: 0,
                idOcorrencia: 0,
                tpContratacao: '',
                nmConsultor: '',
                isOpenModalTicket: false,
                flAvancarEtapaTicket: false,

                dados: {},
                ocorrencia: {},

                sizeDivBtn: '',

                classificacoes_etapas: [],

                refresh_grid: false,
                filtro: [{ active: true }],
                NotLoading: false,
                showFilters: false,
                showErrorMessage: false,
                isOpenModalTrocaConsultor: false,
                noShadow: false,
                haveShadow: 'shadow-v2',
                filtro_status: [
                    "Todos",
                    "Andamento",
                    "Atrasados",
                    "Finalizado",
                    "Fracasso",
                    "Boas Chances",
                ],
                filtro_esfera: [
                    "Todos",
                    "Privado",
                    "Municipal",
                    "Estadual",
                    "Federal",
                    "Sistema S",
                    "Economia Mista",
                ],
                filtro_modalidade: [
                    "Todos",
                    "Dispensa",
                    "Inexigibilidade",
                    "Pregão eletrônico",
                ],

                filtros_Crud: {
                    tpContratacao: "",
                    nmCliente: "",
                    idEtapaAtual: 0,
                    dsLoginConsultor: "",
                    nrCpfCnpj: "",
                    nmSetor: '',
                    cdInstituicao: "",
                    nmUf: "",
                    Esfera: "",
                    Modalidade: "",
                    dsStatus: "",
                    dtInicioAbertura: "",
                    dtFimAbertura: "",
                    dtInicioAberturaAtualizada: "",
                    dtFimAberturaAtualizada: "",
                    dtInicio: "",
                    dtFim: "",
                    flEmpenho: "",
                    flNpEvents: "",
                    tpOrigemInscricao: "",
                    idTipoInscricao: 0
                },

                filtro_status_selects: [],
                filtro_esfera_selects: [],
                filtro_modalidade_selects: [],

                filtro_text: "",
                filtered: "",

                equipe: [],


                parentEl: [],


                setConsultorSelect: [],
                permissoes: { flAdministrador: 'Não', flGestorNovos: 'Não', flGestorRenovacao: 'Não', flGestorSucessoCliente: 'Não' },

                customWidthDate: '',
                customStyleBtnEdi: '',
                customSpanText: '',
                total_registros: 0,

                etapa: {
                    idEtapa: 0,
                    nmEtapa: "",
                    nrPerncentualConcluido: 0,
                },


                setTabId: 0,


                hasBottonChangeProc: '',
                header_selected: [],
                OcorrenciaClassificacaoEtapaCrud: {
                    idOcorrencia: 0,
                    idSetorClassificacao: 0,
                    idSetorClassificacaoEtapa: 0,
                    dsObservacao: ''
                },
                ocorrencia_classificacoes: [],
                ocorrencia_classificacao: { idSetorClassificacao: 0 },
                ocorrencia_classificacao_etapa: { idSetorClassificacaoEtapa: 0 },
                dinamicHeightConsChange: 'min-height:calc(100vh - 21rem);',

                index_tab: 0,

                grid_inscricao_selected: 0,
                grid_participante_selected: 0,

                filtro_flCancelado: false,
                filtro_flSemPassaporte: false,
                filtro_flSemAtribuir: false,
                filtro_flSemOficina: false,
                filtro_flSemConfirmado: false,
                filtro_flSemCredenciamento: false,

                reset: false,
                primeiraTrocaModulo: true,
            };
        },
        methods: {
            return_dropEvento_reset() {
                this.reset = false;
            },
            input_evento(evento, novoValorEvento) {
                if (this.EventoSelected.idEvento !== evento.idEvento) {
                    this.EventoSelected = evento;
                }

                this.reset = novoValorEvento;
            },
            formatarData(dataISO) {
                const data = new Date(dataISO);
                const dia = String(data.getDate()).padStart(2, '0');
                const mes = String(data.getMonth() + 1).padStart(2, '0');
                const ano = data.getFullYear();
                const horas = String(data.getHours()).padStart(2, '0');
                const minutos = String(data.getMinutes()).padStart(2, '0');

                return `${dia}/${mes}/${ano} ${horas}:${minutos}`;
            },
            abreOcorrencia(_idOcorrencia) {
                this.p_idOcorrencia = _idOcorrencia;
                this.isOpenModalOcorrencia = true;
            },
            getAmbito() {
                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ambito/Get', {
                    headers: this.$api.getTokenComercial(),
                    params: '',
                    notLoading: true
                }).then(response => {
                    const data = response.data.data.rows;

                    const selectAllOption = { id: -1, nmAmbito: "Todos" };

                    this.filtro_ambitos = [selectAllOption, ...data];
                });
            },
            openModalInscricao(_idInscricao) {
                this.grid_inscricao_selected = _idInscricao;
                this.isOpenModalInscricao = true;
            },
            openModalParticipantes(_idInscricao) {
                this.grid_inscricao_selected = _idInscricao;
                this.isOpenModalParticipantes = true;
            },
            openModalParticipante(_idInscricao, _idParticipante) {
                this.grid_inscricao_selected = _idInscricao;
                this.grid_participante_selected = _idParticipante;
                this.isOpenModalParticipante = true;
            },
            openModalStatusParticipante(_idParticipante) {
                this.grid_participante_selected = _idParticipante;
                this.isOpenModalStatusParticipante = true;
            },
            openModalStatusInscricao(_idInscricao) {
                this.grid_inscricao_selected = _idInscricao;
                this.isOpenModalStatusInscricao = true;
            },
            openModalDisparo(_idInscricao, _idParticipante) {
                this.grid_inscricao_selected = _idInscricao;
                this.grid_participante_selected = _idParticipante;
                this.isOpenModalDisparoAlerta = true;
            },
            getStyleqtdParticipantesCadastrados(qtdParticipantesCadastrados, qtdParticipantes) {
                if (qtdParticipantesCadastrados === qtdParticipantes) {
                    return 'fw-bold text-success';
                } else if (qtdParticipantesCadastrados > 0 && qtdParticipantesCadastrados < qtdParticipantes) {
                    return 'fw-bold text-warning';
                } else {
                    return 'fw-bold text-danger';
                }
            },
            getStyleqtdParticipantesOficinas(qtdParticipantesOficinas, qtdParticipantes) {
                if (qtdParticipantesOficinas === qtdParticipantes) {
                    return 'fw-bold text-success';
                } else if (qtdParticipantesOficinas > 0 && qtdParticipantesOficinas < qtdParticipantes) {
                    return 'fw-bold text-warning';
                } else {
                    return 'fw-bold text-danger';
                }
            },
            getStyleqtdParticipantesConfirmados(qtdParticipantesConfirmados, qtdParticipantes) {
                if (qtdParticipantesConfirmados === qtdParticipantes) {
                    return 'fw-bold text-success';
                } else if (qtdParticipantesConfirmados > 0 && qtdParticipantesConfirmados < qtdParticipantes) {
                    return 'fw-bold text-warning';
                } else {
                    return 'fw-bold text-danger';
                }
            },
            getStyleqtdParticipantesCredenciados(qtdParticipantesCredenciados, qtdParticipantes) {
                if (qtdParticipantesCredenciados === qtdParticipantes) {
                    return 'fw-bold text-success';
                } else if (qtdParticipantesCredenciados > 0 && qtdParticipantesCredenciados < qtdParticipantes) {
                    return 'fw-bold text-warning';
                } else {
                    return 'fw-bold text-danger';
                }
            },
            setTabDataTable(_index) {
                let $this = this;
                $this.index_tab = _index;
                $this.getFiltros();

                $.each($this.valoresTabs, function (index, value) {
                    value.class = _index == index ? 'tab-selected' : 'tab';
                });
                $this.reloadGrid();
            },

            verificaPermissao() {
                if (this.permissoes.flAdministrador === 'Sim') {
                    return true;
                }
                let temPermissao = false;
                //switch (this.Setor_Selected) {
                //    case 'Novos': // Novos
                //        temPermissao = this.permissoes.flGestorNovos === 'Sim';
                //        break;
                //    case 'Renovação': // Sucesso do Cliente
                //        if (this.permissoes.flGestorSucessoCliente == 'Sim' || this.permissoes.flGestorRenovacao === 'Sim') {
                //            temPermissao = true;
                //        }
                //        break;
                //}
                return temPermissao;
            },


            retorna_total_registros(index, total) {
                let $this = this;

                $this.total_registros = total;

            },
            liberaAvancarEtapa(val) {
                this.flAvancarEtapaTicket = val;
            },
            liberaUltimaEtapa(val) {
                if (!val) {
                    this.textAvancarEtapa = 'Avançar Para a Proxima Etapa';
                } else {
                    this.textAvancarEtapa = 'Finalizar Ticket';
                }
            },

            handleTabClick(tabId) {
                if (tabId > 0) {
                    this.setTabId = tabId;
                }
            },

            fecharModal() {
                this.reloadGrid();
                this.isOpenModalInscricao = false;
                this.grid_inscricao_selected = 0;
                this.isOpenModalTrocaConsultor = false;
            },

            getPermissoesUsuario() {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Equipe/GetPermissoesUsuarioModulo?idModulo=' + $this.ModuloSelected.idModulo, {
                    headers: $this.$api.getTokenComercial(),
                    params: ''
                }).then(response => {
                    $this.permissoes = response.data.data;
                })
            },
            getFiltros() {
                let $this = this;

                this.filtered = "";

                switch ($this.index_tab) {
                    case 0:
                        this.filtered += `&tpContato=naoValidados`;
                        break;
                    case 1:
                        this.filtered += `&tpContato=validados`;
                        break;
                    case 2:
                        this.filtered += `&tpContato=ativos`;
                        break;
                    case 3:
                        this.filtered += `&tpContato=cancelados`;
                        break;
                    case 4:
                        this.filtered += `&tpContato=participantes-Oficinas`;
                        break;
                    case 5:
                        this.filtered += `&tpContato=participantes-ativo`;
                        break;
                    case 6:
                        this.filtered += `&tpContato=participantes-cancelados`;
                        break;
                    default:
                }

                if ($this.filtros_Crud.cdLocalizador != '' && $this.filtros_Crud.cdLocalizador != null) {
                    this.filtered += `&cdLocalizador=${$this.filtros_Crud.cdLocalizador}`;
                }
                if ($this.filtros_Crud.cdPassaporte != '' && $this.filtros_Crud.cdPassaporte != null) {
                    this.filtered += `&cdPassaporte=${$this.filtros_Crud.cdPassaporte}`;
                }
                if ($this.filtros_Crud.idAmbito != '' && $this.filtros_Crud.idAmbito != null) {
                    this.filtered += `&idAmbito=${$this.filtros_Crud.idAmbito}`;
                }
                if ($this.filtros_Crud.flEmpenho != '' && $this.filtros_Crud.flEmpenho != null) {
                    this.filtered += `&flEmpenho=${$this.filtros_Crud.flEmpenho}`;
                }
                if ($this.filtros_Crud.nmUf != '' && $this.filtros_Crud.nmUf != null) {
                    this.filtered += `&nmUf=${$this.filtros_Crud.nmUf}`;
                }
                if ($this.filtros_Crud.dsLoginConsultor != '' && $this.filtros_Crud.dsLoginConsultor != null) {
                    this.filtered += `&dsLoginConsultor=${$this.filtros_Crud.dsLoginConsultor}`;
                }
                if ($this.filtros_Crud.flNpEvents != '' && $this.filtros_Crud.flNpEvents != null) {
                    this.filtered += `&flNpEvents=${$this.filtros_Crud.flNpEvents}`;
                }
                if ($this.filtros_Crud.tpOrigemInscricao != '' && $this.filtros_Crud.tpOrigemInscricao != null) {
                    this.filtered += `&tpOrigemInscricao=${$this.filtros_Crud.tpOrigemInscricao}`;
                }
                if ($this.filtros_Crud.idTipoInscricao != '' && $this.filtros_Crud.idTipoInscricao != null) {
                    this.filtered += `&idTipoInscricao=${$this.filtros_Crud.idTipoInscricao}`;
                }

                this.filtered += `&flCancelado=${$this.filtro_flCancelado}`;
                this.filtered += `&flSemPassaporte=${$this.filtro_flSemPassaporte}`;
                this.filtered += `&flSemAtribuir=${$this.filtro_flSemAtribuir}`;
                this.filtered += `&flSemOficina=${$this.filtro_flSemOficina}`;
                this.filtered += `&flSemConfirmado=${$this.filtro_flSemConfirmado}`;
                this.filtered += `&flSemCredenciamento=${$this.filtro_flSemCredenciamento}`;
                this.showFilters = false;
                this.noShadow = false;
                this.haveShadow = 'shadow-v2';

                this.reloadGrid();
            },
            toggleFilters() {
                this.showFilters = !this.showFilters;

                if (this.noShadow == false) {
                    this.noShadow = true;

                } else {
                    this.noShadow = false;
                }

                if (this.haveShadow == 'shadow-v2') {
                    this.haveShadow = 'shadow-none';

                } else {
                    this.haveShadow = 'shadow-v2';
                }


                this.filtro = [{ active: true }];

            },
            closeFilters() {
                this.showFilters = false;

                this.noShadow = false;

                this.haveShadow = 'shadow-v2';

            },
            clearFiltros() {
                this.filtro_ambitos_selects = { idAmbito: 0 };
                this.filtro_estados_selects = [];
                this.filtros_Crud = {
                    tpContratacao: "",
                    nmCliente: "",
                    idEtapaAtual: 0,
                    dsLoginConsultor: "",
                    nmSetor: '',
                    dsStatus: "",
                    nrCpfCnpj: "",
                    cdInstituicao: 0,
                    nmUf: "",
                    Esfera: "",
                    Modalidade: "",
                    dtInicioAbertura: "",
                    dtFimAbertura: "",
                    dtInicioAberturaAtualizada: "",
                    dtFimAberturaAtualizada: "",
                    dtInicio: "",
                    dtFim: "",
                };
                this.filtro_status_selects = [];
                this.filtro_esfera_selects = [];
                this.filtro_modalidade_selects = [];


                $("input[type=date]").val("");
                $("input[type=text]").val("");

                setTimeout(() => {
                    $("input[type=date]").val("");
                    $("input[type=text]").val("");
                }, 200);

                this.filtered = "";
            },
            applyFilter() {
                this.result = this.checkedNames.length;

                $(".btn-t").removeClass("btn-order");
                $(".btn-t").addClass("btn-filter-red");

            },
            clearFilterChecked() {
                this.checkedNames = [];

                $(".btn-t").removeClass("btn-filter-red");
                $(".btn-t").addClass("btn-filter");

            },
            performSearch() {
                this.getFiltros();
            },
            getFormattedDate(date) {
                return moment(date).format("DD/MM/YYYY");
            },

            getModulosUsuario() {
                let $this = this;

                axios
                    .get(process.env.VUE_APP_ROOT_COMERCIAL_API + "/Equipe/GetModulos?flEvento=true", {
                        headers: $this.$api.getTokenComercial(),
                        params: "",
                    })
                    .then((response) => {
                        $this.modulos = response.data.data;
                    });
            },

            getEventosUsuario() {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Equipe/GetEventosUsuario?idModulo=' + $this.ModuloSelected.idModulo, {
                    headers: $this.$api.getTokenComercial(),
                    params: ''
                }).then(response => {
                    $this.eventos = response.data.data;
                })
            },

            getValoresTabs() {
                let $this = this;
                axios.get(
                    process.env.VUE_APP_ROOT_EVENTOS_API +
                    "/Inscricao/GetGerenciamentoInscricoesCount?" + "idModulo=" + $this.ModuloSelected.idModulo + '&idEvento=' + $this.EventoSelected.idEvento + '&filter=' + $this.filtro_text + $this.filtered,
                    { headers: $this.$api.getTokenEventos(), }
                )
                    .then((response) => {
                        $this.valoresTabs = response.data.data;
                        $.each($this.valoresTabs, function (index, value) {
                            value.class = index == $this.index_tab ? 'tab-selected' : 'tab';
                        });
                    });
            },
            getEquipe() {
                let $this = this;
                axios.get(
                    process.env.VUE_APP_ROOT_COMERCIAL_API +
                    "/Equipe/GetEquipeUsuario?idModulo=" + $this.ModuloSelected.idModulo + '&setor=',
                    {
                        headers: $this.$api.getTokenComercial(),
                        params: "",
                    }
                )
                    .then((response) => {
                        $this.equipe = response.data.data;
                        if (this.equipe.length > 1) {
                            $this.filtros_Crud.dsLoginConsultor = '';
                        }
                        else {
                            $this.filtros_Crud.dsLoginConsultor = $this.equipe[0].dsLogin;
                        }
                        $this.getFiltros();
                        $this.reloadGrid();

                    });
            },

            setResult(result) {
                return result;
            },

            gridRefreshed(data_ajax) {
                let $this = this;

                $this.getValoresTabs();
                $this.refresh_grid = false;
                $this.NotLoading = false;
            },
            reloadGrid() {
                let $this = this;
                $this.refresh_grid = true;
            },
            getUrlInscricoes() {
                let $this = this;

                var flCancelado = false;
                var flSelecaoOficina = "Não";
                var url = process.env.VUE_APP_ROOT_EVENTOS_API;

                $this.header_selected = [
                    {
                        class: "col text-center max_w_90",
                        name: "cdPassaporte",
                        text: "Passaporte",
                        order: 0,
                        slot: true
                    },
                    {
                        class: "col text-center",
                        name: "nmParticipante",
                        text: "Nome",
                        order: 0,
                        slot: true
                    },
                    {
                        class: "col text-center",
                        name: "dsEmail",
                        text: "UF / E-mail",
                        order: 0,
                        slot: true
                    },
                    {
                        class: "col text-center max_w_90",
                        name: "flVinculado_Participante",
                        text: "Vinculado",
                        order: 0,
                        slot: true
                    },
                    {
                        class: "col text-center max_w_90",
                        name: "flCancelado_Participante",
                        text: "Ativo",
                        order: 0,
                        slot: true
                    },
                    {
                        class: "col text-center",
                        name: "dsLoginConsultor",
                        text: "Consultor",
                        order: 0,
                        slot: false
                    },
                    {
                        class: "col text-center max_w_180",
                        name: "btns",
                        text: "",
                        actions: true,
                    },
                ];

                switch ($this.index_tab) {
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                        $this.header_selected = [
                            {
                                class: "col text-center max_w_90",
                                name: "cdLocalizador",
                                text: "Localizador",
                                order: 0,
                                slot: true
                            },
                            {
                                class: "col text-center",
                                name: "nmUf",
                                text: "UF / Inscrição",
                                order: 0,
                                slot: true
                            },
                            {
                                class: "col text-center max_w_90",
                                name: "flVinculado",
                                text: "Vinculado",
                                order: 0,
                                slot: true
                            },
                            {
                                class: "col text-center max_w_130",
                                name: "flCancelado",
                                text: "Ativo",
                                order: 0,
                                slot: true
                            },
                            {
                                class: "col text-center max_w_130",
                                name: "qtdParticipantesCadastrados",
                                text: "Passaporte",
                                order: 0,
                                slot: true
                            },
                            {
                                class: "col text-center max_w_130",
                                name: "qtdParticipantesOficinas",
                                text: "Oficina",
                                order: 0,
                                slot: true
                            },
                            {
                                class: "col text-center max_w_130",
                                name: "qtdParticipantesConfirmados",
                                text: "Confirmado",
                                order: 0,
                                slot: true
                            },
                            {
                                class: "col text-center max_w_130",
                                name: "qtdParticipantesCredenciados",
                                text: "Credenciado",
                                order: 0,
                                slot: true
                            },
                            {
                                class: "col max_w_180",
                                name: "btns",
                                text: "",
                                actions: true,
                            },
                        ];
                        return (
                            process.env.VUE_APP_ROOT_EVENTOS_API +
                            "/Inscricao/GetGerenciamentoInscricoes?" +
                            'idEvento=' + $this.EventoSelected.idEvento +
                            $this.filtered
                        );
                    case 4:
                        flSelecaoOficina = 'Sim';
                        url = url + "/Inscricao/GetGerenciamentoParticipantes?" + 'idEvento=' + $this.EventoSelected.idEvento + '&flSelecaoOficina=' + flSelecaoOficina + '&flCancelado=' + flCancelado + $this.filtered;
                        break;
                    case 5:
                        url = url + "/Inscricao/GetGerenciamentoParticipantes?" + 'idEvento=' + $this.EventoSelected.idEvento + '&flSelecaoOficina=' + flSelecaoOficina + '&flCancelado=' + flCancelado + $this.filtered;
                        break;
                    case 6:
                        flCancelado = true;
                        url = url + "/Inscricao/GetGerenciamentoParticipantes?" + 'idEvento=' + $this.EventoSelected.idEvento + '&flSelecaoOficina=' + flSelecaoOficina + '&flCancelado=' + flCancelado + $this.filtered;
                        break;
                    default:
                        break;
                }
                return url;
            },

            reloadAll() {
                this.grid_participante_selected = 0;
                this.grid_inscricao_selected = 0;

                this.isOpenModalStatusParticipante = false;
                this.isOpenModalStatusInscricao = false;
                this.isOpenModalParticipantes = false;
                this.isOpenModalParticipante = false;
                this.isOpenModalInscricao = false;
                this.isOpenModalDisparoAlerta = false;

                this.reloadGrid();
            },
            initTooltips() {
                setTimeout(() => {
                    const tooltipTriggerList = [].slice.call(
                        document.querySelectorAll('[data-bs-toggle="tooltip"]')
                    );
                    tooltipTriggerList.forEach((tooltipTriggerEl) => {
                        var bot = new window.bootstrap.Tooltip(tooltipTriggerEl);

                        bot.hide();
                    });
                }, 2000);
            },
        },
        mounted() {

            this.initTooltips();


            this.getAmbito();
            this.getModulosUsuario();
            this.filtros_Crud.dtInicio = moment()
                .startOf("month")
                .format("YYYY-MM-DD");
            this.filtros_Crud.dtFim = moment()
                .endOf("month")
                .format("YYYY-MM-DD");
            this.getFiltros();
        },
        updated() {

        },
        watch: {
            filtro_ambitos_selects(new_filtro_ambitos_selects, old_filtro_ambitos_selects) {
                this.filtros_Crud.idAmbito = new_filtro_ambitos_selects.idAmbito;
            },
            filtro_estados_selects(new_filtro_estado_selects, old_filtro_estado_selects) {
                if (new_filtro_estado_selects == 'Todos') {
                    this.filtros_Crud.nmUf = ''
                } else {
                    this.filtros_Crud.nmUf = new_filtro_estado_selects.toString();
                }
            },
            setConsultorSelect(newValue, oldValue) {
                if (newValue != '') {
                    this.setConsultor.dsLoginConsultor = newValue.dsLogin;
                }
            },
            ModuloSelected(new_ModuloSelected, old_ModuloSelected) {
                if (new_ModuloSelected) {
                    if (this.primeiraTrocaModulo == true) {
                        this.input_evento({ idEvento: 0 }, false);
                        this.primeiraTrocaModulo = false;
                    }
                    else {
                        this.input_evento({ idEvento: 0 }, true);
                    }
                    this.reloadGrid();
                    this.getEventosUsuario();
                    this.getPermissoesUsuario();

                }
            },
            EventoSelected(n, o) {
                if (n) {
                    this.EventoSelected.idEvento = n.idEvento;
                    this.reloadGrid();
                }
            },
            ocorrencia_classificacao: async function (_new, _old) {
                this.classificacoes_etapas = [];
                this.OcorrenciaClassificacaoEtapaCrud.idSetorClassificacao = _new.idSetorClassificacao;
                this.classificacoes_etapas = await this.getClassificacaoEtapas(_new.cdSetorClassificacao);
            },
            ocorrencia_classificacao_etapa(_new, _old) {
                this.OcorrenciaClassificacaoEtapaCrud.idSetorClassificacaoEtapa = _new.idSetorClassificacaoEtapa;
            },


            filtro_status_selects(
                new_filtro_status_selects,
                old_filtro_status_selects
            ) {
                this.filtros_Crud.dsStatus = new_filtro_status_selects.toString();
            },

            filtro_esfera_selects(
                new_filtro_esfera_selects,
                old_filtro_esfera_selects
            ) {
                this.filtros_Crud.Esfera = new_filtro_esfera_selects.toString();
            },

            filtro_modalidade_selects(
                new_filtro_modalidade_selects,
                old_filtro_modalidade_selects
            ) {
                if (new_filtro_modalidade_selects == 'Pregão eletrônico') {
                    this.filtros_Crud.Modalidade = 'Pregão eletr'
                } else {
                    this.filtros_Crud.Modalidade = new_filtro_modalidade_selects.toString();

                }
            },


            filtro_text: function (newVal, oldVal) {
                let $this = this;

                $this.filtro[0].value = newVal;
                //$this.NotLoading = true;
                //$this.filtros_Crud.nmCliente = newVal;
                //$this.getFiltros();
                //$this.refresh_grid = true;
            },
        },
    };
</script>

<style scoped lang="scss">

    .d-flex-tabs {
        margin-right: 10px;
        margin-left: 10px;
    }

    .backdrop {
        height: calc(100vh - 3.8rem);
    }


    .customSelect .vue-select {
        height: 34px !important;
        display: flex !important;
        align-items: center !important;
        padding: 2px 10px !important;
    }

    .tabs {
        display: flex;
        justify-content: center;
        align-items: flex-start;
        flex-direction: column;
        margin-bottom: 20px;
        height: 50px;
        padding: 0 5px;
        min-width: 200px;
    }

    .tab {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        border: 1px solid #9f3029 !important;
        border-radius: 5px !important;
        height: 100%;
        width: 100%;
    }

    .tab-selected {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        border: 1px solid #9f3029 !important;
        border-radius: 5px !important;
        height: 100%;
        width: 100%;
        background-color: #9f3029;
        color: white;
    }

    .tab:hover {
        cursor: pointer;
        background-color: #9f3029;
        color: white;
    }

    .tabs-title {
        font-size: 12px;
    }

    .tabs-valor {
        font-size: 14px;
        font-weight: bold;
    }

    .div-select {
        min-width: 265px;
    }


    .btn-aplicar-filter {
        width: 250px;
        height: 35px;
        background: #9f3029;
        box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.25);
        border: 1px solid #9f2d39;
        border-radius: 5px;
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 140.62%;
        align-items: center;
        text-align: center;
        color: #ffffff;
    }

    .btn-red-v2 {
        border: 1px solid #9f3029 !important;
    }

    .btn-white-v2 {
        width: 140px;

        &.v3 {
            border-radius: 5px !important;
            width: 120px;
        }
    }

    .v3 {
        width: 160px !important;
        max-width: 170px !important;
        padding: 0px 4px !important;
        max-height: 35px !important;
        height: 35px !important;
    }

    .filled {
        border: 1px solid #299f4a;
    }

    .btn-order {
        box-sizing: border-box;
        width: 50px;
        height: 40px;
        background: #ffffff;
        box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.25);
        border-radius: 5px;
    }

    .btn-filter {
        box-sizing: border-box;
        width: 50px;
        height: 40px;
        background: #ffffff;
        box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.25);
        border-radius: 5px;
    }

    .btn-filter-red {
        box-sizing: border-box;
        width: 50px;
        height: 40px;
        left: 1830px;
        top: 21px;
        background: #9f3029;
        border: 1px solid #9f2d39;
        box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.25);
        border-radius: 5px;
        color: #ffffff;
    }

    .spinner-grow-static {
        display: inline-block;
        width: 2rem;
        height: 2rem;
        vertical-align: text-bottom;
        background-color: currentColor;
        border-radius: 50%;
        opacity: .75;
    }

    a {
        text-decoration: none;
    }

    .btn-ativo {
        width: 40px;
        background-color: transparent;
        border-color: var(--bs-btn-hover-border-color);
    }

    .btn-ativo:hover {
        --bs-btn-border-color: #6c757d;
    }

    .custom-tooltip {
        background-color: #333 !important;
        border-radius: 8px !important;
    }

    </style>